import React from 'react';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import { editCustomInspectionPath, customInspectionCustomInspectionSectionsPath, customInspectionQuestionsPath } from '../../../routes';
const getColumnsDefinition = ({ toggling, onToggleActive }) => [
    {
        label: translate('table.name', { namespace }),
        dataKey: 'name',
        renderer: ({ item }) => (React.createElement("span", { className: item.active ? '' : 'inactive-row' },
            item.name,
            !item.active && React.createElement("i", { className: "fa-light fa-eye-slash ml-2", "aria-hidden": "true" })))
    },
    {
        label: translate('table.status', { namespace }),
        dataKey: 'active',
        width: 100,
        renderer: ({ item }) => (React.createElement("span", { className: item.active ? '' : 'inactive-row' }, item.active ? translate('table.active', { namespace }) : translate('table.inactive', { namespace })))
    },
    {
        label: '',
        dataKey: 'id',
        width: 160,
        renderer: ({ item }) => (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: "qmb-control--icon", title: item.active ? translate('table.inactive', { namespace }) : translate('table.active', { namespace }), disabled: toggling === item.id, onClick: () => onToggleActive(item.id) },
                React.createElement("i", { className: item.active ? 'fa-light fa-ban' : 'fa-light fa-check-circle', "aria-hidden": "true" })),
            React.createElement("a", { href: customInspectionCustomInspectionSectionsPath(item.id), className: "qmb-control--icon action-icon", title: translate('sections_button', { namespace }) },
                React.createElement("i", { className: "fa-light fa-list", "aria-hidden": "true" })),
            React.createElement("a", { href: customInspectionQuestionsPath(item.id), className: "qmb-control--icon action-icon", title: translate('questions_button', { namespace }) },
                React.createElement("i", { className: "fa-light fa-circle-question", "aria-hidden": "true" })),
            React.createElement("a", { href: editCustomInspectionPath(item.id), className: "qmb-control--icon action-icon", title: translate('edit', { namespace: 'generic' }) },
                React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" }))))
    }
];
export default getColumnsDefinition;
